import React from "react";
import Lottie from "react-lottie";
import PropTypes from "prop-types";

const LottieComponent = (props) => {
    const defaultOptions = {
        loop: props.loop,
        autoplay: true,
        animationData: props.animation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };
    return <Lottie options={defaultOptions} height={props.height} width={props.width} style={props.styled} />;
};

LottieComponent.propTypes = {
    loop: PropTypes.bool.isRequired,
    animationData: PropTypes.string,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    styled: PropTypes.object,
    animation: PropTypes.object
};

export default LottieComponent;
